export default "__VITE_ASSET__BHWo8ts5__"